export const SET_SYSTEM_BANNERS = "SET_SYSTEM_BANNERS";
export const DISMISS_SYSTEM_BANNER = "DISMISS_SYSTEM_BANNER";
export const CLEAR_DISMISSED_BANNERS = "CLEAR_DISMISSED_BANNERS";
